var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.table},[_c('SimpleTable',{attrs:{"columns":_vm.columns,"data":_vm.relevantWorkspaces,"localize-headers":""},scopedSlots:_vm._u([{key:"activationState",fn:function(ref){
var value = ref.value;
var id = ref.row.id;
return [_c('WorkspaceActivationStateInput',{attrs:{"value":value},on:{"input":function($event){return _vm.onInput({id: id, desiredState: $event})}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }